/* =========================================================
   <alnashir-rail> — محرّك شريط المنتجات.

   يُحمّل من القسم بـ defer، فينفّذ بعد اكتمال تحليل الصفحة كلها.
   هذا وحده يقتل الخلل الذي أبقى الأسهم ميتة في كل البلوكات عدا الأول:
   السكربت الداخلي كان يُعرّف العنصر أثناء التحليل، فيُستدعى
   connectedCallback لحظة قراءة وسم الفتح — قبل وصول أزرار الأسهم
   إلى الـ DOM — فيرجع querySelector لها null ولا يُربط أي مستمع نقر.
   البلوك الأول وحده كان ينجو لأن سكربته يأتي بعد ماركبه.

   ومع ذلك نحتفظ بحارس علامة النهاية [data-rail-end] كطبقة ثانية،
   تحسّباً لأي قالب يحقن القسم ديناميكياً.

   RTL: إشارة scrollLeft تختلف بين المتصفحات، لذلك لا نقرأها كموضع
   مطلق أبداً — نقيس مواضع العناصر بـ getBoundingClientRect ونضيف
   الفرق إلى scrollLeft. الفرق بصري وصحيح في كل الأوضاع.

   ── تمرير لا نهائي (v5) ─────────────────────────────────────
   المشكلة السابقة: عند وصول المستخدم لآخر منتج بالسحب، يتوقف
   الشريط ويظهر فراغ بعده — يحس المستخدم أن "المنتجات خلصت".

   الحل: نستنسخ كل البطاقات مرتين — نسخة قبل الأصل ونسخة بعده،
   فيصبح الشريط: [نسخة-قبل][الأصل][نسخة-بعد]. نبدأ العرض من
   أول عنصر في "الأصل". فور دخول المستخدم منطقة إحدى النسختين
   (بالسحب اليدوي أو بالأسهم)، نقفز فوراً بلا أي انيميشن إلى نفس
   الموضع تماماً داخل "الأصل" — والقفزة غير محسوسة لأن البطاقة
   المستنسخة مطابقة تماماً for leniنقة الأصلية. النتيجة: تمرير مستمر
   لا نهائي بدون أي فراغ، بالسحب أو بالأسهم أو بالكيبورد.
   ========================================================= */
(function () {
  if (window.customElements && customElements.get('alnashir-rail')) return;

  var rafThrottle = function (fn) {
    var queued = false;
    return function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; fn(); });
    };
  };

  class AlnashirRail extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      // Below-fold rails keep their server-rendered links and cards, and only
      // attach measurements and interaction listeners near the viewport.
      if ('IntersectionObserver' in window) {
        var rail = this;
        this._initObserver = new IntersectionObserver(function (entries) {
          if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
          rail._initObserver.disconnect();
          rail._initObserver = null;
          rail.init(true);
        }, { rootMargin: '400px 0px' });
        this._initObserver.observe(this);
        return;
      }
      if (this.init()) return;

      var self = this;

      if ('MutationObserver' in window) {
        this._mo = new MutationObserver(function () { self.init(); });
        this._mo.observe(this, { childList: true });
      }

      if (document.readyState === 'loading') {
        this._onReady = function () { self.init(true); };
        document.addEventListener('DOMContentLoaded', this._onReady);
      } else {
        requestAnimationFrame(function () { self.init(true); });
      }
    }

    /* force = التحليل انتهى يقيناً، فلا حاجة لانتظار علامة النهاية */
    init(force) {
      if (this._ready) return true;
      if (!force && !this.querySelector('[data-rail-end]')) return false;

      this.viewport = this.querySelector('[data-rail-viewport]');
      this.track = this.querySelector('[data-rail-track]');
      if (!this.viewport || !this.track || !this.track.children.length) return false;

      this._ready = true;

      if (this._mo) { this._mo.disconnect(); this._mo = null; }
      if (this._onReady) {
        document.removeEventListener('DOMContentLoaded', this._onReady);
        this._onReady = null;
      }

      this.prevBtn = this.querySelector('[data-rail-prev]');
      this.nextBtn = this.querySelector('[data-rail-next]');
      this.bar = this.querySelector('[data-rail-bar]');
      this.rtl = getComputedStyle(this).direction === 'rtl';

      this.loopEnabled = false;
      this._loopCount = this.track.children.length;

      var self = this;
      this.refresh = rafThrottle(this.update.bind(this));

      this.viewport.addEventListener('scroll', this.refresh, { passive: true });
      window.addEventListener('resize', this.refresh, { passive: true });
      window.addEventListener('orientationchange', this.refresh, { passive: true });

      if (this.prevBtn) this.prevBtn.addEventListener('click', this.page.bind(this, -1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', this.page.bind(this, 1));

      this.viewport.addEventListener('keydown', this.onKey.bind(this));
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('submit', this.onSubmit.bind(this));
      this.addEventListener('pointerover', this.loadAlternateImage.bind(this));
      this.addEventListener('focusin', this.loadAlternateImage.bind(this));

      this.initDrag();

      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(this.refresh);
        this.ro.observe(this.viewport);
        this.ro.observe(this.track);
      }

      /* القسم تحت الشاشة قد يُقاس بعرض صفر، فيظن أن لا شيء للتمرير.
         أعد القياس لحظة اقترابه من الشاشة. */
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) self.refresh();
          }
        }, { rootMargin: '250px 0px' });
        this.io.observe(this);
      }

      this._onSectionLoad = function () { self.refresh(); };
      document.addEventListener('shopify:section:load', this._onSectionLoad);
      document.addEventListener('shopify:section:select', this._onSectionLoad);

      requestAnimationFrame(this.refresh);

      return true;
    }

    loadAlternateImage(event) {
      if (event.type === 'pointerover' && (event.pointerType !== 'mouse' || !window.matchMedia('(hover: hover) and (pointer: fine)').matches)) return;
      var card = event.target && event.target.closest ? event.target.closest('.nbss-card') : null;
      if (!card || !this.contains(card)) return;

      var image = card.querySelector('img[data-deferred-src]');
      if (!image) return;

      image.addEventListener('load', function () {
        image.style.visibility = '';
      }, { once: true });
      image.srcset = image.getAttribute('data-deferred-srcset') || '';
      image.src = image.getAttribute('data-deferred-src');
      image.removeAttribute('data-deferred-srcset');
      image.removeAttribute('data-deferred-src');
    }

    disconnectedCallback() {
      if (this._initObserver) { this._initObserver.disconnect(); this._initObserver = null; }
      window.removeEventListener('resize', this.refresh);
      window.removeEventListener('orientationchange', this.refresh);
      if (this._lazyObserver) this._lazyObserver.disconnect();
      if (this._onSectionLoad) {
        document.removeEventListener('shopify:section:load', this._onSectionLoad);
        document.removeEventListener('shopify:section:select', this._onSectionLoad);
      }
      if (this.ro) this.ro.disconnect();
      if (this.io) this.io.disconnect();
      if (this._mo) this._mo.disconnect();
      if (this._onReady) document.removeEventListener('DOMContentLoaded', this._onReady);
    }

    setupLoop() {
      this.loopEnabled = false;
      this._loopCount = this.track.children.length;
    }

    markClone(node) {
      node.setAttribute('aria-hidden', 'true');
      var focusables = node.querySelectorAll('a, button, input, select, textarea');
      for (var i = 0; i < focusables.length; i++) {
        focusables[i].setAttribute('tabindex', '-1');
      }
    }

    /* عرض البطاقة بالبكسل من العرض الحقيقي للشريط */
    sizeCards() {
      var w = this.viewport.clientWidth;
      if (!w) return false;

      var pv = w < 600
        ? Math.max(1.5, Math.min(2.4, w / 180))
        : Math.max(2, Math.min(6, Math.floor((w + 16) / 240)));
      this.style.setProperty('--nbss-per-view', pv);

      /* نستخدم العدد الأصلي للمنتجات (قبل الاستنساخ) لهذا الشرط،
         حتى لا تتأثر مقاسات البطاقات بمضاعفة العناصر ثلاث مرات. */
      var count = this._loopCount || this.track.children.length;
      if (count && pv > count) pv = count;

      var gap = parseFloat(getComputedStyle(this.track).columnGap);
      if (isNaN(gap)) gap = 0;

      var cardW = (w - (pv - 1) * gap) / pv;
      if (!(cardW > 0)) return false;

      var next = cardW.toFixed(2) + 'px';
      if (next !== this._cardW) {
        this._cardW = next;
        this.style.setProperty('--nbss-card-w', next);
        return 'changed';
      }
      return 'stable';
    }

    get items() {
      return Array.prototype.slice.call(this.track.children);
    }

    metrics() {
      var items = this.items;
      if (!items.length) return null;
      var v = this.viewport.getBoundingClientRect();
      var first = items[0].getBoundingClientRect();
      var max = this.viewport.scrollWidth - this.viewport.clientWidth;
      var travelled = this.rtl ? (first.right - v.right) : (v.left - first.left);
      return { v: v, items: items, max: max, travelled: Math.max(0, Math.min(travelled, max)) };
    }

    alignDelta(item) {
      var v = this.viewport.getBoundingClientRect();
      var r = item.getBoundingClientRect();
      return this.rtl ? (r.right - v.right) : (r.left - v.left);
    }

    /* يحاذي عنصراً فوراً دون أي حركة أو انيميشن — يُستخدم لضبط نقطة
       البداية ولقفزات الحلقة اللانهائية بحيث لا يشعر بها المستخدم. */
    alignInstant(item) {
      if (!item) return;
      var prev = this.viewport.style.scrollBehavior;
      this.viewport.style.scrollBehavior = 'auto';
      this.viewport.scrollLeft += this.alignDelta(item);
      this.viewport.style.scrollBehavior = prev || '';
    }

    leadIndex() {
      var items = this.items;
      var v = this.viewport.getBoundingClientRect();
      var best = 0, bestDist = Infinity;
      for (var i = 0; i < items.length; i++) {
        var r = items[i].getBoundingClientRect();
        var d = Math.abs(this.rtl ? (v.right - r.right) : (r.left - v.left));
        if (d < bestDist) { bestDist = d; best = i; }
      }
      return best;
    }

    perView() {
      var items = this.items;
      if (items.length < 2) return 1;
      var pitch = Math.abs(
        items[1].getBoundingClientRect().left - items[0].getBoundingClientRect().left
      );
      if (!pitch) return 1;
      return Math.max(1, Math.round(this.viewport.clientWidth / pitch));
    }

    glide(delta, smooth) {
      var behavior = smooth === false ? 'auto' : 'smooth';
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) behavior = 'auto';
      this.viewport.scrollTo({ left: this.viewport.scrollLeft + delta, behavior: behavior });
    }

    page(dir) {
      var items = this.items;
      if (!items.length) return;
      var step = this.perView();
      var lead = this.leadIndex();
      var target = lead + dir * step;

      if (this.loopEnabled) {
        target = Math.max(0, Math.min(items.length - 1, target));
      } else {
        target = Math.max(0, Math.min(items.length - 1, target));
      }
      this.glide(this.alignDelta(items[target]));
    }

    snapNearest() {
      var items = this.items;
      if (!items.length) return;
      this.glide(this.alignDelta(items[this.leadIndex()]));
    }

    /* يكتشف دخول المستخدم منطقة إحدى النسختين المستنسختين ويقفز فوراً
       (بلا انيميشن) للموضع المطابق داخل المجموعة الأصلية. البطاقة
       المستنسخة مطابقة بصرياً تماماً، فالقفزة غير محسوسة إطلاقاً. */
    checkLoop() {
      if (!this.loopEnabled) return;
      var n = this._loopCount;
      var items = this.items;
      var lead = this.leadIndex();

      if (lead < n) {
        this.alignInstant(items[lead + n]);
      } else if (lead >= n * 2) {
        this.alignInstant(items[lead - n]);
      }
    }

    update() {
      if (!this.viewport.clientWidth) return;
      var sizeState = this.sizeCards();
      if (!sizeState) return;
      if (sizeState === 'changed') {
        this.refresh();
        return;
      }

      var m = this.metrics();
      if (!m) return;

      if (this.loopEnabled) {
        this.classList.remove('is-static');
        if (this.prevBtn) this.prevBtn.disabled = false;
        if (this.nextBtn) this.nextBtn.disabled = false;
      } else {
        var scrollable = m.max > 2;
        this.classList.toggle('is-static', !scrollable);

        if (this.prevBtn) this.prevBtn.disabled = !scrollable || m.travelled <= 1;
        if (this.nextBtn) this.nextBtn.disabled = !scrollable || m.travelled >= m.max - 1;

        if (this.bar && scrollable) {
          var ratio = this.viewport.clientWidth / this.viewport.scrollWidth;
          var width = Math.max(12, Math.min(100, ratio * 100));
          var progress = m.max ? m.travelled / m.max : 0;
          this.bar.style.width = width + '%';
          this.bar.style.insetInlineStart = (progress * (100 - width)) + '%';
        }
      }

      /* لا نقفز أثناء السحب اليدوي مباشرة، ننتظر انتهاءه (snapNearest
         يستدعي refresh لاحقاً) حتى لا يشعر المستخدم بأي قفزة أثناء اللمس. */
      if (this.loopEnabled && !this.classList.contains('is-dragging')) {
        this.checkLoop();
      }
    }

    onKey(e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== 'Home' && e.key !== 'End') return;
      e.preventDefault();
      if (e.key === 'Home' || e.key === 'End') {
        var items = this.items;
        var idx = e.key === 'Home' ? (this.loopEnabled ? this._loopCount : 0) : (this.loopEnabled ? this._loopCount * 2 - 1 : items.length - 1);
        this.glide(this.alignDelta(items[idx]));
        return;
      }
      var forward = this.rtl ? e.key === 'ArrowLeft' : e.key === 'ArrowRight';
      this.page(forward ? 1 : -1);
    }

    initDrag() {
      var self = this;
      var vp = this.viewport;
      var down = false, startX = 0, startLeft = 0, dragging = false;

      vp.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch' || e.button !== 0) return;
        if (e.target.closest && e.target.closest('button, input, select, textarea')) return;
        down = true; dragging = false;
        startX = e.clientX;
        startLeft = vp.scrollLeft;
        self.classList.add('is-grab');
      });

      vp.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (!dragging && Math.abs(dx) < 4) return;
        if (!dragging) {
          dragging = true;
          self.classList.add('is-dragging');
          try { vp.setPointerCapture(e.pointerId); } catch (err) {}
        }
        vp.scrollLeft = startLeft - dx;
        e.preventDefault();
      });

      var release = function () {
        if (!down) return;
        down = false;
        self.classList.remove('is-grab');
        if (dragging) {
          dragging = false;
          self.classList.remove('is-dragging');
          self._blockClickUntil = Date.now() + 220;
          requestAnimationFrame(function () {
            self.snapNearest();
            requestAnimationFrame(function () { self.checkLoop(); });
          });
        }
      };

      vp.addEventListener('pointerup', release);
      vp.addEventListener('pointercancel', release);
      vp.addEventListener('pointerleave', release);

      this.addEventListener('click', function (e) {
        if (self._blockClickUntil && Date.now() < self._blockClickUntil) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);

      this.addEventListener('dragstart', function (e) {
        if (self.classList.contains('is-dragging')) e.preventDefault();
      });

      /* اللمس على الجوال: نستمع لنهاية اللمس لتشغيل فحص الحلقة بعد
         استقرار السحب، إضافةً لما يوفره حدث scroll أصلاً. */
      vp.addEventListener('touchend', function () {
        setTimeout(function () { self.checkLoop(); }, 60);
      }, { passive: true });
    }

    onSubmit(e) {
      var form = e.target.closest('form.nbss-form');
      if (!form) return;
      e.preventDefault();
      this.addToCart(form, form.querySelector('[data-atc]'), false);
    }

    onClick(e) {
      var buy = e.target.closest('[data-buy]');
      if (!buy) return;
      var form = buy.closest('form.nbss-form');
      if (!form) return;
      e.preventDefault();
      this.addToCart(form, buy, true);
    }

    checkoutUrl() {
      var cart = this.dataset.cartUrl || '/cart';
      return cart.replace(/\/cart\/?$/, '/checkout');
    }

    addToCart(form, btn, goCheckout) {
      var self = this;
      if (this._busy || !btn) return;
      this._busy = true;

      var label = btn.querySelector('[data-label]') || btn;
      var original = label.textContent;
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');

      fetch(this.dataset.cartAdd || '/cart/add', {
        method: 'POST',
        headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
        .then(function (res) {
          return res.json().catch(function () { return null; }).then(function (data) {
            if (!res.ok) throw new Error((data && (data.description || data.message)) || 'add_failed');
            return data;
          });
        })
        .then(function () {
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');

          if (goCheckout) {
            window.location.href = self.checkoutUrl();
            return;
          }

          if (self.dataset.afterAdd === 'cart') {
            window.location.href = self.dataset.cartUrl || '/cart';
            return;
          }

          btn.classList.add('is-done');
          label.textContent = self.dataset.addedText || 'Added';
          self.syncCart();

          setTimeout(function () {
            btn.classList.remove('is-done');
            label.textContent = original;
            self._busy = false;
          }, 1800);
        })
        .catch(function () {
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
          btn.classList.add('is-error');
          label.textContent = self.dataset.errorText || 'Try again';
          setTimeout(function () {
            btn.classList.remove('is-error');
            label.textContent = original;
            self._busy = false;
          }, 2000);
        });
    }

    syncCart() {
      var base = this.dataset.cartUrl || '/cart';
      fetch(base + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var nodes = document.querySelectorAll(
            '[data-cart-count], .cart-count-bubble span:first-child, .cart-count, #CartCount, .site-header__cart-count'
          );
          for (var i = 0; i < nodes.length; i++) {
            if (!/^\s*\d*\s*$/.test(nodes[i].textContent)) continue;
            nodes[i].textContent = cart.item_count;
          }
          ['cart:refresh', 'cart:updated', 'cart:build'].forEach(function (name) {
            document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { cart: cart } }));
          });
        })
        .catch(function () {});
    }
  }

  customElements.define('alnashir-rail', AlnashirRail);
})();

